module.exports = __webpack_public_path__ + "img/thumbnail-header-23.21d474c.jpeg";